import {garageLocatorData} from './garageLocator';
import {dateSelectorData, formatTime} from './dateSelector';
import {convertDate} from './summary';
import {serviceDescriptionData} from './serviceDescription';
import {replacementData} from './replacements';
import {currency} from '../globals/config';
import {serviceSelectorData} from '../../appointment-tool/modules/serviceSelector';

const $ = jQuery;
const $appointmentToolContainer = $('#appointment-tool');

export function confirmModule() {
    toggleCalendarOptions();
}

export function prepareConfirmationData() {
    const garageInfo = `<span>${garageLocatorData.name}</span>
                        <span>${garageLocatorData.address}</span>
                        <span>${garageLocatorData.phone}</span>`;

    const dateInfo = `<span>${convertDate(dateSelectorData.fullDate)}</span>
                      <span>${formatTime(dateSelectorData.time)}</span>`;

    applyData(garageInfo, 'garage');
    applyData(dateInfo, 'date');

    let replacementPrice = 0;
    if (replacementData.price) {
        replacementPrice = replacementData.price;
    }

    let totalPrice;
    if ($appointmentToolContainer.length > 0) {
        totalPrice = (serviceSelectorData.totalPrice + replacementPrice).toFixed(2);
    } else {
        let totalPriceFromServices = serviceDescriptionData.reduce((acc, service) => acc + service.price, 0);
        totalPrice = (totalPriceFromServices + replacementPrice).toFixed(2);
    }
    applyData(totalPrice + ` ${currency}`, 'total');

    fillCalendar();
}

function applyData(data, field) {
    const $field = $(`#informative-${field}`);

    if (data) {
        $field.html(data);

        $field.parent().show();
    } else {
        $field.parent().hide();
    }
}

function toggleCalendarOptions() {
    const $addToCalendar = $('.js-qt-informative--add-to-calendar');

    if ($addToCalendar.length > 0) {
        $addToCalendar.on('click', function () {
            $(this).toggleClass('active');
        });

        $addToCalendar.find('.c-qt-informative__calendar-container').on('mouseleave', function () {
            if ($addToCalendar.hasClass('active')) {
                $addToCalendar.removeClass('active');
            }
        });
    }
}

function fillCalendar() {
    let duration = 1;
    let title;

    if ($appointmentToolContainer.length > 0) {
        duration = serviceSelectorData.totalDuration;
        title = `${serviceSelectorData.items[0].name} - ${garageLocatorData.name}`;
    } else {
        title = `${serviceDescriptionData.name} - ${garageLocatorData.name}`;
    }

    $.ajax({
        type: 'POST',
        url: menaObject.ajaxurl,
        dataType: 'html',
        data: {
            action: 'qtGenerateCalendarLinks',
            title: title,
            startDate: dateSelectorData.fullDate,
            endDate: duration,
            location: garageLocatorData.address,
        },
        success: function (response) {
            if (response) {
                $('.js-qt-informative--add-to-calendar').find('.c-qt-informative__calendar-container').html(response);
            }
        },
    });
}
